import * as __glob_0 from './../about-cus.ts';
import * as __glob_1 from './../card-fan.ts';
import * as __glob_2 from './../cms-search.ts';
import * as __glob_3 from './../dept-list.ts';
import * as __glob_4 from './../drag-scroll.ts';
import * as __glob_5 from './../growth-slider.ts';
import * as __glob_6 from './../growth-timeline.ts';
import * as __glob_7 from './../image-trail-simple.ts';
import * as __glob_8 from './../image-trail.ts';
import * as __glob_9 from './../img-flash.ts';
import * as __glob_10 from './../inline-brand.ts';
import * as __glob_11 from './../int-filter.ts';
import * as __glob_12 from './../intro-plx.ts';
import * as __glob_13 from './../life-list.ts';
import * as __glob_14 from './../news-slider.ts';
import * as __glob_15 from './../odometer.ts';
import * as __glob_16 from './../office.ts';
import * as __glob_17 from './../opr-cards.ts';
import * as __glob_18 from './../opr-slider.ts';
import * as __glob_19 from './../petal-spin.ts';
import * as __glob_20 from './../speaker-ticker.ts';
import * as __glob_21 from './../stamp-card.ts';
import * as __glob_22 from './../sticky-card.ts';
import * as __glob_23 from './../story-swiper.ts';
import * as __glob_24 from './../team-card-inertia.ts';
import * as __glob_25 from './../team-grid-infinite.ts';
import * as __glob_26 from './../title-inertia.ts';
import * as __glob_27 from './../util-btn.ts';
import * as __glob_28 from './../util-music.ts';
import * as __glob_29 from './../util-partners.ts';
import * as __glob_30 from './../util-time.ts';
import * as __glob_31 from './../vid-reverse-loop.ts';
import * as __glob_32 from './../video-cascade.ts';
import * as __glob_33 from './../video-player.ts';
const modules = { "./../about-cus.ts": __glob_0, "./../card-fan.ts": __glob_1, "./../cms-search.ts": __glob_2, "./../dept-list.ts": __glob_3, "./../drag-scroll.ts": __glob_4, "./../growth-slider.ts": __glob_5, "./../growth-timeline.ts": __glob_6, "./../image-trail-simple.ts": __glob_7, "./../image-trail.ts": __glob_8, "./../img-flash.ts": __glob_9, "./../inline-brand.ts": __glob_10, "./../int-filter.ts": __glob_11, "./../intro-plx.ts": __glob_12, "./../life-list.ts": __glob_13, "./../news-slider.ts": __glob_14, "./../odometer.ts": __glob_15, "./../office.ts": __glob_16, "./../opr-cards.ts": __glob_17, "./../opr-slider.ts": __glob_18, "./../petal-spin.ts": __glob_19, "./../speaker-ticker.ts": __glob_20, "./../stamp-card.ts": __glob_21, "./../sticky-card.ts": __glob_22, "./../story-swiper.ts": __glob_23, "./../team-card-inertia.ts": __glob_24, "./../team-grid-infinite.ts": __glob_25, "./../title-inertia.ts": __glob_26, "./../util-btn.ts": __glob_27, "./../util-music.ts": __glob_28, "./../util-partners.ts": __glob_29, "./../util-time.ts": __glob_30, "./../vid-reverse-loop.ts": __glob_31, "./../video-cascade.ts": __glob_32, "./../video-player.ts": __glob_33 };
// console.log("modules -> []", modules);

// Extend HTMLElement interface to include our custom property
declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

export function createCycles(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      // Check if THIS SPECIFIC ELEMENT is already initialized
      if (htmlElement._moduleInitialized) {
        return null; // Skip this specific element
      }

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Mark THIS SPECIFIC ELEMENT as initialized
            htmlElement._moduleInitialized = true;

            return moduleFn(htmlElement, htmlElement.dataset);
          } catch (error) {
            // Remove the flag if initialization fails
            delete htmlElement._moduleInitialized;
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}

// Optional: Helper function to manually clear initialization for testing
export function clearModuleInitialization(element: HTMLElement) {
  delete element._moduleInitialized;
}
